import React from "react";
import { FaFacebookF, FaLinkedinIn } from "react-icons/fa";
import { ImArrowUpRight } from "react-icons/im";
import { PiInstagramLogoFill } from "react-icons/pi";
import { Link } from "react-router-dom";

const Follows = () => {
  return (
    <React.Fragment>
      <div className="contact-section mb-50 mt-50">
        <div className="container-lg container-fluid">
          <div className="row g-lg-4 gy-5">
            <div className="col-lg-8 col-md-10">
              <div className="section-title text-animation">
                <div className="section-title text-animation custom-color">
                  <h2>
                    Follow <span>Us</span>
                  </h2>
                </div>

                <div className="dash-and-paragraph">
                  <div className="dash" />
                  <div className="content-and-social">
                    <p>
                      Text will coming soon...Text will coming soon...Text will
                      coming soon...Text will coming soon...Text will coming
                      soon...
                    </p>
                    <div className="social-area">
                     
                      <ul>
                        <li>
                          <a href="#">
                            <FaFacebookF className="bx bxl-facebook" />
                          </a>
                        </li>
                        <li>
                          <a href="#">
                            <FaLinkedinIn className="bx bxl-linkedin" />
                          </a>
                        </li>
                        <li>
                          <a href="#">
                            <PiInstagramLogoFill className="bx bxl-instagram-alt" />
                          </a>
                        </li>
                      </ul>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="col-lg-4 col-md-2 d-lg-flex justify-content-end align-items-center">
              <div className="btn_wrapper">
                <Link className="circle-btn btn-hovers" to="/contactUs">
                  
                  <ImArrowUpRight />
                  Contact <strong>Us</strong>
                  <span />
                </Link>
              </div>
            </div>
          </div>
        </div>
      </div>
    </React.Fragment>
  );
};

export default Follows;
